export default {
  drinks: "BEVANDE",
  food: "CIBO",
  dessert: "DOLCE",
  first: "Primo",
  second: "Secondo",
  mainCourses: "PIATTI PRINCIPALI",
  comments: "Commenti:",
  invoice: "Fattura",
  cookies: "Cookies",
  privacy: "Privacy",
  termsAndConditions: "Termini e Condizioni",
  noRecordMessage:
    "Nessun risultato trovato. Per favore, controlla i filtri di ricerca!",
  askFor: "Chiedere",
  keep: "Mantenere",
  close: "Chiudere",
  everything: "Ogni cosa",
  done: "Fatto",
  toShare: "CONDIVIDERE",
  companyName: "Nome della ditta",
  postalCode: "codice postale",
  town: "Cittadino",
  address: "Indirizzo",
  nameIsRequired: "Il nome è obbligatorio",
  addressIsRequired: "L'indirizzo è obbligatorio",
  NIFIsRequired: "NIF è richiesto",
  postalCodeIsRequired: "Il codice postale è obbligatorio",
  cityIsRequired: "La città è obbligatoria",
  emailIsRequired: "L'e-mail è obbligatoria",
  theEmailMustBeValid: "L'email deve essere valida",
  charging: "In carica..."
};
